import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import HeaderTopright from "../../../containers/logged_user_components/structure_components/desktop_screens/header_component/header_left/header_left";
import authActions from "../../../redux/auth/action";
import uiActions from "../../../redux/ui/action";
import userPreferenceActions from "../../../redux/user_preference/action";
import userActivityActions from "../../../redux/user_activity/action";
import userTestsExercisesAction from "../../../redux/user_tests_exercises/action";
import userTwilioDetailsAction from "../../../redux/twilio_chat/action";
import userBookmarkAction from "../../../redux/user_bookmark/action";
import images from "../../../utilities/images/images";
import { isEmpty } from "../../../custom_utilities/custom_useful_functions";
import DashboardProfileAvatar from "./DashboardProfileAvatar";
import "./DashboardProfileDropdown.css";
import "../../../containers/logged_user_components/structure_components/desktop_screens/header_component/header_left/header_left.scss";

const DashboardProfileDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isAnushaasan, setIsAnushaasan] = useState(null);
  const containerRef = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.auth.user);
  const userPreference = useSelector((state) => state.userPreference);
  const rollNo = useSelector((state) => state.auth.user?.roll_no);
  const authToken = useSelector((state) => state.auth.authToken);
  const tokenType = useSelector((state) => state.auth.tokenType);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handlePointerDown = (event) => {
      if (
        event.target.closest("#preference_selection_modal") ||
        event.target.closest(".modal-backdrop")
      ) {
        return;
      }
      if (containerRef.current?.contains(event.target)) return;
      setIsOpen(false);
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  useEffect(() => {
    const storedValue = localStorage.getItem("is_anushaasan");
    if (storedValue !== null) {
      setIsAnushaasan(storedValue === "true");
    }
  }, []);

  useEffect(() => {
    if (!rollNo || !authToken || !tokenType) return;

    const storedValue = localStorage.getItem("is_anushaasan");
    if (storedValue !== null) {
      setIsAnushaasan(storedValue === "true");
      return;
    }

    const fetchAttendanceAccess = async () => {
      try {
        const response = await axios.post(
          "https://learning.motion.ac.in/motioneducation/api/v1/Parentdashboard1",
          { roll_no: rollNo },
          {
            headers: {
              Authorization: `${tokenType} ${authToken}`,
            },
          }
        );

        if (response.data.status === 200) {
          const value = response.data.is_anushaasan;
          localStorage.setItem("is_anushaasan", value ? "true" : "false");
          setIsAnushaasan(value);
        }
      } catch {
        // ignore
      }
    };

    fetchAttendanceAccess();
  }, [rollNo, authToken, tokenType]);

  const handleUserLogout = () => {
    localStorage.removeItem("is_anushaasan");
    dispatch(authActions.logoutUser());
    dispatch(uiActions.removeAnimation());
    dispatch(userPreferenceActions.removePreferenceData());
    dispatch(userActivityActions.removeActivityData());
    dispatch(userTestsExercisesAction.removeTestsExercisesData());
    dispatch(userTwilioDetailsAction.removeTwilioDetails());
    dispatch(userBookmarkAction.removeBookmarkData());
    history.push("/");
  };

  const closeMenu = () => setIsOpen(false);

  const renderProfileImage = () => {
    if (!isEmpty(userData) && userData?.image?.length) {
      return <img src={userData.image} alt={userData?.name || "User"} />;
    }
    return <img src={images.dummy_user_img} alt="Default user" />;
  };

  return (
    <Fragment>
      <div className="dashboard-profile-dropdown" ref={containerRef}>
        <DashboardProfileAvatar
          image={userData?.image}
          name={userData?.name}
          onClick={() => setIsOpen((prev) => !prev)}
        />

        {isOpen ? (
          <div
            className="dashboard-profile-dropdown__menu"
            role="menu"
            aria-label="Profile menu"
          >
            <div className="dashboard-profile-dropdown__header">
              <div className="dashboard-profile-dropdown__user">
                <div className="dashboard-profile-dropdown__avatar">{renderProfileImage()}</div>
                <div className="dashboard-profile-dropdown__user-text">
                  <p className="dashboard-profile-dropdown__name">
                    {!isEmpty(userData) ? userData?.name : "User"}
                  </p>
                  <p className="dashboard-profile-dropdown__phone">
                    {!isEmpty(userData) ? userData?.mobile : ""}
                  </p>
                </div>
              </div>
              {userData?.is_subscribe === 1 ? (
                <p className="dashboard-profile-dropdown__badge">
                  <img src={images.user_activity_12} alt="Subscribed" />
                </p>
              ) : null}
            </div>

            <div className="dashboard-profile-dropdown__course">
              <div className="headerLeft_wrapper">
                <div className="headerLeft_inner_wrapper">
                  <HeaderTopright
                    userPreference={userPreference}
                    userData={userData}
                    redirectToDashboardOnUpdate
                  />
                </div>
              </div>
            </div>

            <div className="dashboard-profile-dropdown__links">
              <Link
                to="/user_edit_profile"
                className="dashboard-profile-dropdown__link"
                onClick={closeMenu}
              >
                <span>Profile</span>
                <img src={images.right_Ar} alt="" aria-hidden="true" />
              </Link>
              <Link
                to="/wallet"
                className="dashboard-profile-dropdown__link"
                onClick={closeMenu}
              >
                <span>My Wallet</span>
                <img src={images.right_Ar} alt="" aria-hidden="true" />
              </Link>
              <Link
                to={{
                  pathname: "/user_edit_profile",
                  state: { tab: "packages" },
                }}
                className="dashboard-profile-dropdown__link"
                onClick={closeMenu}
              >
                <span>My Packages</span>
                <img src={images.right_Ar} alt="" aria-hidden="true" />
              </Link>
              {isAnushaasan ? (
                <Link
                  to={{
                    pathname: "/user_attendance",
                    state: { isAnushaasan },
                  }}
                  className="dashboard-profile-dropdown__link"
                  onClick={closeMenu}
                >
                  <span>My Attendance</span>
                  <img src={images.right_Ar} alt="" aria-hidden="true" />
                </Link>
              ) : null}
              <button
                type="button"
                className="dashboard-profile-dropdown__logout"
                onClick={() => {
                  closeMenu();
                  setShowLogoutModal(true);
                }}
              >
                <img src={images.header_2} alt="" aria-hidden="true" />
                Logout
              </button>
            </div>
          </div>
        ) : null}
      </div>

      {showLogoutModal ? (
        <div className="dashboard-profile-dropdown__logout-overlay">
          <div className="dashboard-profile-dropdown__logout-modal">
            <p>Are you sure you want to logout?</p>
            <div className="dashboard-profile-dropdown__logout-actions">
              <button
                type="button"
                className="dashboard-profile-dropdown__logout-yes"
                onClick={() => {
                  handleUserLogout();
                  setShowLogoutModal(false);
                }}
              >
                Yes
              </button>
              <button
                type="button"
                className="dashboard-profile-dropdown__logout-no"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default DashboardProfileDropdown;
